import jsPDF from 'jspdf';
import 'jspdf-autotable';

import { PurchaseItem } from '../../../../features/slice/purchases/purchase.schema';

interface Order {
    orderNumber: string;
    date: string;
    items: PurchaseItem[];
    subtotal: number;
    tax: number;
    total: number;
    paymentMethod: string;
    paymentStatus: string;
}

export const purchaseReceipt = (
    order: Order,
    action: 'preview' | 'print' = 'print',
) => {
    // Create new PDF document with larger height to ensure all content fits
    const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: [80, 297],
        hotfixes: ['px_scaling'],
    });

    // Set font
    doc.setFont('Helvetica');
    doc.setFontSize(10);

    // Starting position
    let y = 5;
    const leftMargin = 2;
    const width = 70;

    // Store name
    doc.setFontSize(14);
    doc.text('LINK PHARMACY', doc.internal.pageSize.width / 2, y, {
        align: 'center',
    });
    y += 5;

    // Store address
    doc.setFontSize(8);
    doc.text('3900, Trunk Road', doc.internal.pageSize.width / 2, y, {
        align: 'center',
    });
    y += 4;
    doc.text('Feni, Bangladesh', doc.internal.pageSize.width / 2, y, {
        align: 'center',
    });
    y += 4;
    doc.text('Tel: (123) 456-7890', doc.internal.pageSize.width / 2, y, {
        align: 'center',
    });
    y += 6;

    // Order details
    doc.setFontSize(10);
    doc.text(`Order #: 01`, leftMargin, y);
    y += 4;
    doc.text(`Date: ${order.date}`, leftMargin, y);
    y += 6;

    // Items table
    const tableData = order.items.map((item, i) => [
        `${i + 1}`,
        item.product.name,
        item.quantity.toString(),
        `${(item.purchase_price * item.quantity).toFixed(2)}`,
    ]);

    (doc as any).autoTable({
        startY: y,
        head: [['SL', 'Item', 'Qty', 'Price']],
        body: tableData,
        theme: 'plain',
        styles: {
            font: 'helvetica', // Default 'courier' না
            fontSize: 11,
            lineWidth: 0.1,
            overflow: 'linebreak',
            cellPadding: 1,
            fontStyle: 'bold',
        },
        headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            fontSize: 11,
            fontStyle: 'bold',
        },
        margin: { left: leftMargin },
        tableWidth: width,

        columnStyles: {
            0: {
                cellWidth: 5,
                cellPadding: 1,
                halign: 'left',
                overflow: 'linebreak',
            }, // Item
            1: { cellWidth: 42, cellPadding: 1, overflow: 'linebreak' }, // Item
            2: { cellWidth: 10, cellPadding: 1, halign: 'center' }, // Qty
            3: { cellWidth: 15, cellPadding: 1, halign: 'left' }, // Price
        },
        didDrawCell: function (data: any) {
            const { doc, cell } = data;
            doc.setDrawColor(0); // Black
            doc.setLineWidth(0.1);
            doc.rect(cell.x, cell.y, cell.width, cell.height); // Draw border manually
        },
    });

    y = (doc as any).lastAutoTable.finalY + 4;

    // Totals
    const totalsStyle = {
        fontSize: 10,
        cellPadding: 1,
        lineWidth: 0,
        minCellHeight: 6,
    };

    (doc as any).autoTable({
        startY: y,
        body: [
            ['Subtotal:', '', `${order.subtotal.toFixed(2)}`],
            ['Tax:', '', `${order.tax.toFixed(2)}`],
            ['Total:', '', `${order.total.toFixed(2)}`],
        ],
        theme: 'plain',
        styles: totalsStyle,
        columnStyles: {
            0: { cellWidth: 30 },
            1: { cellWidth: 20 },
            2: { cellWidth: 20, halign: 'right', fontStyle: 'bold' },
        },
        margin: { left: leftMargin },
        tableWidth: width,
    });

    y = (doc as any).lastAutoTable.finalY + 4;

    doc.setFontSize(10);
    doc.text(
        `Payment Status: ${String(order.paymentStatus).toUpperCase()}`,
        leftMargin,
        y,
    );
    y += 8;

    // Thank you message
    doc.setFontSize(8);
    doc.text(
        'Thank you for your purchase!',
        doc.internal.pageSize.width / 2,
        y,
        {
            align: 'center',
        },
    );
    y += 4;
    doc.text('Please come again', doc.internal.pageSize.width / 2, y, {
        align: 'center',
    });

    if (action === 'print') {
        doc.autoPrint();
        const blob = doc.output('blob');
        const blobUrl = URL.createObjectURL(blob);
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';

        iframe.src = blobUrl;
        document.body.appendChild(iframe);
        iframe.contentWindow?.print();
    } else {
        const pdfDataUri = doc.output('datauristring');
        const newWindow = window.open();
        if (newWindow) {
            newWindow.document.write(
                `<iframe width='100%' height='100%' src='${pdfDataUri}'></iframe>`,
            );
        }
    }
};
